import { useReceiptStore } from "@elixir/stores";
import { ExpandingTextareaFormField } from "ui";

export default function RemarksInput() {
  const remarks = useReceiptStore((state) => state.remarks);
  const setRemarks = useReceiptStore((state) => state.setRemarks);

  return (
    <ExpandingTextareaFormField
      title="Remarks"
      alignment="horizontal"
      value={remarks}
      onChange={(e) => {
        setRemarks(e.target.value);
      }}
    />
  );
}
